export const FIRM_SETTINGS_PATH = "/bp-firmsetting";

export const NAVBAR_ROUTES = Object.freeze({
  home: "bp-home",
  caseNavigator: "bp-navigator",
  workList: "work-list",
  calendar: "bp-calendar",
  gauge: "bp-checkLists",
  chat: "chat",
  flaggedCases: "bp-flaggedcases",
  firmReporting: "bp-firmReporting",
  litigationCentral: "bp-litigationCentral",
  directory: "bp-lawfirmdirectory",
  accounting: "bp-accounting",
  library: "bp-library",
  copilot: "bp-copilot",
  createClient: "create-client",
  inbox: "inbox",
  search: "search",
  "landing-page": "landing-page",
});

const NAVBAR_ROUTE_KEYS = new Set(Object.values(NAVBAR_ROUTES).map((route) => route.toLowerCase()));
const TREATMENT_ROUTE_KEY = "treatment";
const TREATMENT_PAGE_ID = 8;

export const normalizeRouteKey = (value) => {
  if (!value) return "";

  const pathname = String(value).split(/[?#]/, 1)[0];
  return (pathname.split("/").filter(Boolean)[0] || "").toLowerCase();
};

export const isNavbarRoute = (pathname) => NAVBAR_ROUTE_KEYS.has(normalizeRouteKey(pathname));

export const isFirmSettingsRoute = (pathname) =>
  normalizeRouteKey(pathname) === normalizeRouteKey(FIRM_SETTINGS_PATH);

export const isAlwaysAllowedRoute = (pathname) =>
  isNavbarRoute(pathname) || isFirmSettingsRoute(pathname);

export const routeMatchesPage = (pathname, page) => {
  if (!page) return false;

  const routeKey = normalizeRouteKey(pathname);
  if (routeKey === TREATMENT_ROUTE_KEY) {
    return Number(page.id) === TREATMENT_PAGE_ID;
  }

  return Boolean(routeKey) && normalizeRouteKey(page.page_url) === routeKey;
};

export const isSidebarPage = (page) => page?.show_on_sidebar === true;

export const getLoadedGlobalPages = (pagesState) => {
  const hasLoadedPages =
    pagesState?.status === "succeeded" ||
    (pagesState?.status === "loading" && Boolean(pagesState?.lastFetched));

  return hasLoadedPages && Array.isArray(pagesState?.allPages) ? pagesState.allPages : null;
};

export const routeIsSidebarRestricted = (pathname, globalPages) => {
  if (isAlwaysAllowedRoute(pathname)) return false;
  if (!Array.isArray(globalPages)) return null;

  return globalPages.some((page) => isSidebarPage(page) && routeMatchesPage(pathname, page));
};

export const caseAllowsRoute = (pathname, casePages) =>
  Array.isArray(casePages) &&
  casePages.some((page) => isSidebarPage(page) && routeMatchesPage(pathname, page));
